export default function FormList({
  list = ["first", "second"],
  values = false,
  title = "title",
  name = "name",
  placeholder = "",
  id = "",
  onChange,
  value,
}) {
  return (
    <div>
      <span className="py-2 block">{title}</span>
      <select
        name={name}
        type="text"
        placeholder={placeholder}
        onChange={onChange}
        value={value}
        required
        className="w-80 rounded-md indent-2 p-1 bg-gray-800 border border-gray-700 text-gray-300 mb-2 focus:border-green-400"
      >
        {list.map((el, i) => (
          <option value={values ? values[i] : el} key={el}>
            {el}
          </option>
        ))}
      </select>
    </div>
  );
}
